import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Link, Typography } from '@mui/material'

import LoadingSpinner from '../LoadingSpinner'
import { fetchArticle, formatArticleDate } from './articleRequest'

// Every article of a collection (`/news`), in the server's order, from
// `/<collection>.json`. Help pages don't show their dates (`showDates`).
export default function ArticleIndex({ collection, title, showDates = true }) {
  const [result, setResult] = React.useState(null)

  React.useEffect(() => {
    let current = true
    fetchArticle(`/${collection}`).then((fetched) => {
      if (current) setResult(fetched)
    })
    document.title = title
    return () => { current = false }
  }, [collection, title])

  if (!result) return <LoadingSpinner />

  const articles = result.json?.articles || []
  return (
    <Box sx={{ width: '100%', maxWidth: 700 }}>
      <Typography component='h1' variant='h4' gutterBottom>
        {title}
      </Typography>
      {!result.json && (
        <Typography variant='body1'>
          This page could not be loaded. Please try again in a moment.
        </Typography>
      )}
      {result.json && articles.length === 0 && (
        <Typography variant='body1'>Nothing here yet.</Typography>
      )}
      {articles.map((article) => (
        <Box component='section' key={article.slug} sx={{ mt: 3 }}>
          <Typography component='h2' variant='h6'>
            <Link component={RouterLink} to={`/${collection}/${article.slug}`}>
              {article.title}
            </Link>
          </Typography>
          {showDates && (
            <Typography variant='body2' color='text.secondary'>
              {formatArticleDate(article.date)}
            </Typography>
          )}
          {article.summary && (
            <Typography variant='body1'>{article.summary}</Typography>
          )}
        </Box>
      ))}
    </Box>
  )
}
